/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 7:45 AM
 *
 */

import { createSlice } from '@reduxjs/toolkit';
import { Member } from 'types/MemberTypes';
import { ROLE } from 'types/RoleEnum';

interface AuthState {
  token: string;
  role: ROLE;
  user: Member;
  verified: boolean;
}

const initialState: Partial<AuthState> = {
  verified: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload;
    },
    addUser: (state, action) => {
      state.user = action.payload;
    },
    addRole: (state, action) => {
      state.role = action.payload;
    },
    removeAuth: (state) => {
      state.token = undefined;
      state.user = undefined;
      state.role = undefined;
    },
    setVerified: (state) => {
      state.verified = true;
    },
  },
});

export default authSlice.reducer;
